<div class="step_section resumen_web">
    <h4 class="form-signin-heading"><strong>Finalizar: Resumen de su solicitud</strong></h4>
    <hr />
    <br>
    <div class="row text-justify" align="center">
        <div class="col-md-12">
            <div class="fondoResaltado"> <h5>Tramite: {{ n_form }} {{ tramite }}</h5></div>
        </div>

    </div>
    <hr id="hr-propiedad" *ngIf="propiedad" />
    <div class="row text-justify" *ngIf="propiedad">
        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> home </mat-icon>
            </div>
            <div class="col-md-3"><span><strong>Propiedad:</strong></span></div>
            <div class="col-md-2 fondoResaltado">Rol</div>
            <div class="col-md-6 fondoResaltado">Direccion Completa</div>
        </div>
        <div class="col-md-12">
            <div class="col-md-4 text-center py-4"></div>
            <div class="col-md-2 text-center py-4 texto">{{propiedad[0].rol}}</div>
            <div class="col-md-6 text-center py-4 texto">{{propiedad[0].direccion_completa}}</div>

        </div>
    </div>
    <hr id="hr-propietario" *ngIf="propietarios" />
    <div class="row text-justify" *ngIf="propietarios">
        <!--<div class="col-md-12" *ngFor="let propietario of propietarios">-->
        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> person </mat-icon>
            </div>
            <div class="col-md-3"><strong>Propietarios:</strong></div>
            <div class="col-md-2 fondoResaltado">Rut</div>
            <div class="col-md-6 fondoResaltado">Nombre Completo</div>
        </div>
        <div class="col-md-12" *ngFor="let propietario of propietarios">
            <div class="col-md-4"></div>
            <div class="col-md-2 texto" >{{propietario.rut}}</div>
            <div class="col-md-6 texto">{{propietario.nombre_completo}}</div>

            <!-- <div class="col-md-2 texto" *ngIf="propietario.rut < 50000000">{{propietario.apellido_pat}}</div>
            <div class="col-md-2 texto" *ngIf="propietario.rut < 50000000"> {{propietario.apellido_mat}}</div> -->
        </div>
    </div>
    <hr id="hr-representante" *ngIf="representantes" />
    <div class="row text-justify" *ngIf="representantes">
        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> person </mat-icon>
            </div>
            <div class="col-md-3">
                <strong>Representantes Legales:</strong>
            </div>
            <div class="col-md-2 fondoResaltado">Rut</div>
            <div class="col-md-2 fondoResaltado">Nombre</div>
            <div class="col-md-2 fondoResaltado">Apellido Pat</div>
            <div class="col-md-2 fondoResaltado">Apellido Mat</div>
        </div>
        <div class="col-md-12 " id="display-representante" *ngFor="let representante of representantes">
            <div class="col-md-4"></div>
            <div class="col-md-2 texto">{{representante.rut}}</div>
            <div class="col-md-2 texto">{{representante.nombre}}</div>
            <div class="col-md-2 texto">{{representante.apellido_pat}}</div>
            <div class="col-md-2 texto">{{representante.apellido_mat}} </div>
        </div>
    </div>
    <hr id="hr-arquitecto" *ngIf="arquitectos" />
    <div class="row text-justify" *ngIf="arquitectos">
        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> person </mat-icon>
            </div>
            <div class="col-md-3 "><strong>Arquitectos Patrocinantes:</strong></div>
            <div class="col-md-2 fondoResaltado">Rut</div>
            <div class="col-md-2 fondoResaltado">Nombre</div>
            <div class="col-md-2 fondoResaltado">Apellido Pat</div>
            <div class="col-md-2 fondoResaltado">Apellido Mat</div>
        </div>
        <div class="col-md-12 " id="display-arquitecto" *ngFor="let arquitecto of arquitectos">
            <div class="col-md-4"></div>
            <div class="col-md-2 texto">{{arquitecto.rut}}</div>
            <div class="col-md-2 texto">{{arquitecto.nombre}}</div>
            <div class="col-md-2 texto">{{arquitecto.apellido_pat}}</div>
            <div class="col-md-2 texto">{{arquitecto.apellido_mat}}</div>
        </div>
    </div>
    <hr id="hr-empresa" *ngIf="empresas" />
    <div class="row text-justify" *ngIf="empresas">
        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> store </mat-icon>
            </div>
            <div class="col-md-3"><strong>Empresa:</strong></div>
            <div class="col-md-4 fondoResaltado">Rut</div>
            <div class="col-md-4 fondoResaltado">Nombre Empresa</div>
             <div class="col-md-4"></div> 
        </div>
        <div class="col-md-12 " id="display-empresa" *ngFor="let empresa of empresas">
            <div class="col-md-4"></div>
            <div class="col-md-4 texto">{{empresa.rut}}</div>
            <div class="col-md-4 texto">{{empresa.nombre}}</div>
            <div class="col-md-4"></div>

        </div>
    </div>
    <hr id="hr-independiente" *ngIf="independiente" />
    <div class="row text-justify" *ngIf="independiente">
        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> person </mat-icon>
            </div>
            <div class="col-md-3">
                <strong>Revisores Independientes:</strong>
            </div>
            <div class="col-md-2 fondoResaltado">Rut</div>
            <div class="col-md-2 fondoResaltado">Nombre</div>
            <div class="col-md-2 fondoResaltado">Apellido Pat</div>
            <div class="col-md-2 fondoResaltado">Apellido Mat</div>
        </div>
        <div class="col-md-12 texto" id="display-independiente" *ngFor="let independientes of independiente">
            <div class="col-md-4"></div>
            <div class="col-md-2 texto">{{independientes.rut}}</div>
            <div class="col-md-2 texto">{{independientes.nombre}}</div>
            <div class="col-md-2 texto">{{independientes.apellido_pat}}</div>
            <div class="col-md-2 texto">{{independientes.apellido_mat}}</div>
        </div>
    </div>
    <hr id="hr-constructor" *ngIf="constructores" />
    <div class="row text-justify" *ngIf="constructores">
        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> person </mat-icon>
            </div>
            <div class="col-md-3">
                <strong>Constructor:</strong>
            </div>
            <div class="col-md-2 fondoResaltado">Rut</div>
            <div class="col-md-2 fondoResaltado">Nombre</div>
            <div class="col-md-2 fondoResaltado">Apellido Pat</div>
            <div class="col-md-2 fondoResaltado">Apellido Mat</div>
        </div>
        <div class="col-md-12 texto" id="display-constructor" *ngFor="let constructor of constructores">
            <div class="col-md-4"></div>
            <div class="col-md-2 texto">{{constructor.rut}}</div>
            <div class="col-md-2 texto">{{constructor.nombre}}</div>
            <div class="col-md-2 texto">{{constructor.apellido_pat}}</div>
            <div class="col-md-2 texto">{{constructor.apellido_mat}}</div>
        </div>
    </div>
    <hr id="hr-constructor" *ngIf="constructora" />
    <div class="row text-justify" *ngIf="constructora">
        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> store </mat-icon>
            </div>
            <div class="col-md-3">
                <strong>Constructora:</strong>
            </div>
            <div class="col-md-4 fondoResaltado">Rut</div>
            <div class="col-md-4 fondoResaltado">Nombre</div>
            <div class="col-md-4"></div>
        </div>
        <div class="col-md-12 texto" id="display-constructora" *ngFor="let constructoras of constructora">
            <div class="col-md-4"></div>
            <div class="col-md-4 texto">{{constructoras.rut}}</div>
            <div class="col-md-4 texto">{{constructoras.nombre}}</div>
            <div class="col-md-4"></div>
        </div>
    </div>
    <hr id="hr-permisos_recep" *ngIf="permisos_recep" />
    <div class="row text-justify" *ngIf="permisos_recep">
        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> event_note </mat-icon>
            </div>
            <div class="col-md-3">
                <strong>Permisos y Recepciones anteriores:</strong>
            </div>
            <div class="col-md-2 fondoResaltado">Tipo Permiso</div>
            <div class="col-md-1 fondoResaltado" style="padding-bottom: 21px">Permiso</div>
            <div class="col-md-1 fondoResaltado">Fecha Permiso</div>
            <div class="col-md-1 fondoResaltado">N&uacute;mero Permiso</div>
            <div class="col-md-1 fondoResaltado">N Recepci&oacute;n</div>
            <div class="col-md-1 fondoResaltado">Superficie M2</div>
            <div class="col-md-1 fondoResaltado">Fecha Recepci&oacute;n</div>
        </div>
        <div class="col-md-12 texto" id="display-permisos_recep" *ngFor="let perm_recep of permisos_recep">
            <div class="col-md-4"></div>
            <div class="col-md-2 texto">{{perm_recep.tipo_permiso}}</div>
            <div class="col-md-1 texto">{{perm_recep.permiso}}</div>
            <div class="col-md-1 texto">{{perm_recep.fecha}}</div>
            <div class="col-md-1 texto">{{perm_recep.numero}}</div>
            <div class="col-md-1 texto">{{perm_recep.recepcion}}</div>
            <div class="col-md-1 texto">{{perm_recep.superficie}}</div>
            <div class="col-md-1 texto">{{perm_recep.fecha_recep}}</div>
        </div>
    </div>
    <hr id="hr-proyecto" *ngIf="proyecto" />
    <div class="row text-justify" *ngIf="proyecto">
        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> event_note </mat-icon>
            </div>
            <div class="col-md-3">
                <strong>Proyecto:</strong>
            </div>

            <div class="col-md-2 fondoResaltado">Superf. Exist</div>
            <div class="col-md-2 fondoResaltado">Superf.Proyectada</div>
            <div class="col-md-2 fondoResaltado">Superf. Terreno</div>
            <div class="col-md-2 fondoResaltado">Nro Pisos</div>
        </div>
        <div id="display-proyecto texto" *ngFor="let proyectos of proyecto">
            <div class="col-md-4"></div>
            <div class="col-md-2 texto">{{proyectos.superf_existente}}</div>
            <div class="col-md-2 texto">{{proyectos.superf_proyectada}}</div>
            <div class="col-md-2 texto">{{proyectos.superf_terreno}}</div>
            <div class="col-md-2 texto">{{proyectos.npisos}}</div>
        </div>
    </div>
    <hr id="hr-permisos" *ngIf="permisos" />
    <div class="row text-justify" *ngIf="permisos">
        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> event_note </mat-icon>
            </div>
            <div class="col-md-3">
                <strong>Permisos y Resoluciones:</strong>
            </div>
            <div class="col-md-2 fondoResaltado">Permiso Nro</div>
            <div class="col-md-2 fondoResaltado">Fecha</div>
            <div class="col-md-2 fondoResaltado">Superf. M2</div>
            <div class="col-md-2 fondoResaltado">Modificacion Aprob</div>
        </div>
        <div id="display-permiso texto" *ngFor="let permiso of permisos">
            <div class="col-md-4"></div>
            <div class="col-md-2 texto">{{permiso.perm_numero}}</div>
            <div class="col-md-2 texto">{{permiso.perm_fecha}}</div>
            <div class="col-md-2 texto">{{permiso.superfm2}}</div>
            <div class="col-md-2 texto" *ngIf="permiso.modproy == 'SI'">Si</div>
            <div class="col-md-2 texto" *ngIf="permiso.modproy == 'NO'">No</div>
        </div>
    </div>
    <hr id="hr-proyect" *ngIf="caracteristica_proyecto" />
    <div class="row text-justify" *ngIf="caracteristica_proyecto">

        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> event_note </mat-icon>
            </div>
            <div class="col-md-3">
                <strong>Permisos y Resoluciones:</strong>
            </div>
            <div class="col-md-2 fondoResaltado">Destino</div>
            <div class="col-md-2 fondoResaltado" style="padding-bottom: 21px">Superf. Total</div>
            <div class="col-md-2 fondoResaltado" style="padding-bottom: 21px">Nro Pisos</div>
            <div class="col-md-1 fondoResaltado">Cambios Aprob</div>
            <div class="col-md-1 fondoResaltado">Uso Publico</div>
        </div>
        <div id="display-proyect texto" *ngFor="let proyect of caracteristica_proyecto">
            <div class="col-md-4"></div>
            <div class="col-md-2 texto">{{proyect.destino}}</div>
            <div class="col-md-2 texto">{{proyect.supertotal}}</div>
            <div class="col-md-2 texto">{{proyect.npisos}}</div>
            <div class="col-md-1 texto" *ngIf="proyect.modradio == 'SI'">Si</div>
            <div class="col-md-1 texto" *ngIf="proyect.modradio == 'NO'">No</div>
            <div class="col-md-1 texto" *ngIf="proyect.usoradio == 'SI'">Si</div>
            <div class="col-md-1 texto" *ngIf="proyect.usoradio == 'NO'">No</div>
        </div>
    </div>
    <hr id="hr-antecedentes" *ngIf="antecedentes" />
    <div class="row text-justify" *ngIf="antecedentes">

        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> event_note </mat-icon>
            </div>
            <div class="col-md-3">
                <strong>Antecedentes de Permisos y Recepciones:</strong>
            </div>
            <div class="col-md-2 fondoResaltado">Tipo de Permiso</div>
            <div class="col-md-2 fondoResaltado">Permiso</div>
            <div class="col-md-2 fondoResaltado">Numero</div>
            <div class="col-md-1 fondoResaltado">Fecha</div>
            <div class="col-md-1 fondoResaltado">Superficie</div>
        </div>
        <div id="display-antecedente texto" *ngFor="let antecedente of antecedentes">
            <div class="col-md-4"></div>
            <div class="col-md-2 texto">{{antecedente.tipo_permiso}}</div>
            <div class="col-md-2 texto">{{antecedente.permiso}}</div>
            <div class="col-md-2 texto">{{antecedente.numero}}</div>
            <div class="col-md-1 texto">{{antecedente.fecha}}</div>
            <div class="col-md-1 texto">{{antecedente.superficie}}</div>
        </div>
    </div>

    <hr id="hr-ampliacion" *ngIf="ampliacion" />
    <div class="row text-justify" *ngIf="ampliacion">
        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> event_note </mat-icon>
            </div>
            <div class="col-md-3">
                <strong>Antecedentes de la Ampliacion:</strong>
            </div>
            <div class="col-md-2 fondoResaltado">Superf. Permiso</div>
            <div class="col-md-2 fondoResaltado" style="padding-bottom: 21px">superf. Terreno</div>
            <div class="col-md-2 fondoResaltado">Superf. Ampliacion</div>
            <div class="col-md-1 fondoResaltado" style="padding-bottom: 21px">Condominio</div>
            <div class="col-md-1 fondoResaltado">Vivienda Econom.</div>
        </div>
        <div id="display-ampliacion texto" *ngFor="let ampl of ampliacion">
            <div class="col-md-4"></div>
            <div class="col-md-2 texto" >{{ampl.sup_permiso}}</div>
            <div class="col-md-2 texto" >{{ampl.superf_terreno}}</div>
            <div class="col-md-2 texto">{{ampl.superf_amp}}</div>
            <div class="col-md-1 texto" *ngIf="ampl.condominio == 'SI'">Si</div>
            <div class="col-md-1 texto" *ngIf="ampl.condominio == 'NO'">No</div>
            <div class="col-md-1 texto" *ngIf="ampl.economica == 'SI'">Si</div>
            <div class="col-md-1 texto" *ngIf="ampl.economica == 'NO'">No</div>
        </div>
    </div>
    <hr id="hr-antecedentes_edif" *ngIf="antecedentes_edif" />
    <div class="row text-justify" *ngIf="antecedentes_edif">
        <div class="col-md-12">
            <div class="col-md-1">
                <mat-icon aria-label="icon"> event_note </mat-icon>
            </div>
            <div class="col-md-3">
                <strong>Antecedentes de la Edificación:</strong>
            </div>
            <div class="col-md-1 fondoResaltado">Edif. Antigua</div>
            <div class="col-md-1 fondoResaltado">Ampl. Antigua</div>
            <div class="col-md-2 fondoResaltado" style="padding-bottom: 21px">Destino</div>
            <div class="col-md-2 fondoResaltado" style="padding-bottom: 21px">Superf. Total</div>
            <div class="col-md-1 fondoResaltado">Superf. Terreno</div>
            <div class="col-md-1 fondoResaltado">Nro. Pisos</div>
        </div>
        <div id="display-proyecto texto" *ngFor="let ant of antecedentes_edif">
            <div class="col-md-4"></div>
            <div class="col-md-1 texto" *ngIf="ant.edificacion_antigua == 'SI'">Si</div>
            <div class="col-md-1 texto" *ngIf="ant.edificacion_antigua == 'NO'">No</div>
            <div class="col-md-1 texto" *ngIf="ant.ampliacion_antigua == 'SI'">Si</div>
            <div class="col-md-1 texto" *ngIf="ant.ampliacion_antigua == 'NO'">No</div>
            <div class="col-md-2 texto">{{ant.destino}}</div>
            <div class="col-md-2 texto">{{ant.superf_total}}</div>
            <div class="col-md-1 texto">{{ant.superf_terreno}}</div>
            <div class="col-md-1 texto">{{ant.npisos}}</div>
        </div>
    </div>
    <br />
    <hr />
    <div class="form-horizontal">
        <div class="form-group text-center">
            <div class="col-md-12">
                <input type="checkbox" name="aceptar_continuar" id="aceptar_continuar" (change)="ver()" [(ngModel)]="checkbox_checked">
                <label for="aceptar_continuar" class="confirmar">
						Confirme que los datos en pantalla son los correctos para ingresar su solicitud.(<span style="color:red;">*</span>)
				</label>
                <br>
                <label for="aceptar_continuar" class="error" hidden></label>
            </div>
        </div>
    </div>
</div>
<div class="separator"></div>

<div class="step_section resumen_mobile">
    <div class="row">
        <div class="col-sm-12 text-center">
            <h4 class="form-signin-heading"><strong>Finalizar: Resumen de su solicitud</strong></h4>
            <hr />
        </div>
    </div>
    <div class="row text-center" align="center">       
                <div class="col-sm-12 fondoResaltado">
                    <h5>Tramite: {{ n_form }} {{ tramite[n_form] }}</h5>
                </div>
    </div>
    <div  class="row text-center" align="center">
            <div class="col-sm-12">
                <p>&nbsp;</p>
            </div>
            <div class="col-sm-12">
                <mat-icon aria-label="icon"> home </mat-icon>
            </div>
            <div class="col-sm-12">
                <div class="col-sm-12"><span><strong>Propiedad:</strong></span></div>
            </div>
    </div>
    <div class="row text-center" *ngIf="propiedad">
            <div class="col-sm-12 fondoResaltado">Rol
            </div>
            <div class="col-sm-12 texto">{{propiedad[0].rol}}
            </div>
    </div>
    <div class="row text-center" *ngIf="propiedad">
            <div class="col-sm-12 fondoResaltado">Dirección Completa
            </div>
            <div class="col-sm-12 texto">{{propiedad[0].direccion_completa}}</div>
    </div>

    <div  class="row text-center" align="center">
        <div class="col-sm-12">
            <p>&nbsp;</p>
        </div>
        <div class="col-sm-12">
            <mat-icon aria-label="icon"> person </mat-icon>
        </div>
        <div class="col-sm-12">
            <div class="col-sm-12"><span><strong>Propietarios:</strong></span></div>
        </div>
    </div>
    <div class="row text-center" *ngIf="propietarios">
        <div class="col-sm-12 fondoResaltado">RUT
        </div>
        <div class="col-sm-12 texto" *ngFor="let propietario of propietarios">{{propietario.rut}}
        </div>
    </div> 
    <div class="row text-center" *ngIf="propietarios">
        <div class="col-sm-12 fondoResaltado">Nombre Completo
        </div>
        <div class="col-sm-12 texto" *ngFor="let propietario of propietarios">{{propietario.nombre_completo}}</div>
    </div>

    <div class="row text-center" align="center">
        <div class="col-sm-12">
            <p>&nbsp;</p>
        </div>
        <div class="col-sm-12">
            <mat-icon aria-label="icon"> person </mat-icon>
        </div>
        <div class="col-sm-12">
            <div class="col-sm-12"><span><strong>Representantes Legales:</strong></span></div>
        </div>
    </div>
    <div class="row text-center" *ngIf="representantes">
        <div class="col-sm-12 fondoResaltado">RUT
        </div>
        <div class="col-sm-12 texto" *ngFor="let representante of representantes">{{representante.rut}}
        </div>
    </div>
    <div class="row text-center" *ngIf="representantes">
        <div class="col-sm-12 fondoResaltado">Nombre
        </div>
        <div class="col-sm-12 texto" *ngFor="let representante of representantes">{{representante.nombre}}
        </div>
    </div>
    <div class="row text-center" *ngIf="representantes">
        <div class="col-sm-12 fondoResaltado">Apellido Paterno
        </div>
        <div class="col-sm-12 texto" *ngFor="let representante of representantes">{{representante.apellido_pat}}</div>
    </div>
    <div class="row text-center" *ngIf="representantes">
        <div class="col-sm-12 fondoResaltado">Apellido Materno
        </div>
        <div class="col-sm-12 texto" *ngFor="let representante of representantes">{{representante.apellido_mat}}</div>
    </div>

    <div class="row text-center" align="center">
        <div class="col-sm-12">
            <p>&nbsp;</p>
        </div>
        <div class="col-sm-12">
            <mat-icon aria-label="icon"> person </mat-icon>
        </div>
        <div class="col-sm-12">
            <div class="col-sm-12"><span><strong>Arquitectos Patrocinantes:</strong></span></div>
        </div>
    </div>
    <div class="row text-center" *ngIf="arquitectos">
        <div class="col-sm-12 fondoResaltado">RUT
        </div>
        <div class="col-sm-12 texto" *ngFor="let arquitecto of arquitectos">{{arquitecto.rut}}
        </div>
    </div>
    <div class="row text-center" *ngIf="arquitectos">
        <div class="col-sm-12 fondoResaltado">Nombre
        </div>
        <div class="col-sm-12 texto" *ngFor="let arquitecto of arquitectos">{{arquitecto.nombre}}
        </div>
    </div>
    <div class="row text-center" *ngIf="arquitectos">
        <div class="col-sm-12 fondoResaltado">Appellido Paterno
        </div>
        <div class="col-sm-12 texto" *ngFor="let arquitecto of arquitectos">{{arquitecto.apellido_pat}}
        </div>
    </div>
    <div class="row text-center" *ngIf="arquitectos">
        <div class="col-sm-12 fondoResaltado">Apellido Materno
        </div>
        <div class="col-sm-12 texto" *ngFor="let arquitecto of arquitectos">{{arquitecto.apellido_mat}}
        </div>
    </div>   
    
    <div class="row text-center" align="center">
        <div class="col-sm-12">
            <p>&nbsp;</p>
        </div>
        <div class="col-sm-12">
            <mat-icon aria-label="icon"> store </mat-icon>
        </div>
        <div class="col-sm-12">
            <div class="col-sm-12"><span><strong>Empresa:</strong></span></div>
        </div>
    </div>
    <div class="row text-center" *ngIf="empresas">
        <div class="col-sm-12 fondoResaltado">RUT:
        </div>
        <div class="col-sm-12 texto" *ngFor="let empresa of empresas">{{empresa.rut}}
        </div>
    </div>
    <div class="row text-center" *ngIf="empresas">
        <div class="col-sm-12 fondoResaltado">Nombre Empresa:
        </div>
        <div class="col-sm-12 texto" *ngFor="let empresa of empresas">{{empresa.nombre}}
        </div>
    </div>
    <div class="form-horizontal">
        <div class="form-group text-center">
            <div class="col-md-12">
                <input type="checkbox" name="aceptar_continuar" id="aceptar_continuar" (change)="ver()"
                    [(ngModel)]="checkbox_checked">
                <label for="aceptar_continuar" class="confirmar">
                    Confirme que los datos en pantalla son los correctos para ingresar su solicitud.(<span
                        style="color:red;">*</span>)
                </label>
                <br>
                <label for="aceptar_continuar" class="error" hidden></label>
            </div>
        </div>
    </div>

</div>




    

